import "./style.css";
import { e as et } from "./abstract-base-CRxgOxBJ-DPjBGsyw-Bk4UnKtu.js";
import { I } from "./breakpoints-BOBcTZS0-ClGzfJyz-C5oR-xi6.js";
import { e, a } from "./lifecycle-decorators-CUsT9aHq-Dtp3uB6c-C47lzYll.js";
var u = Object.defineProperty, B = Object.getOwnPropertyDescriptor, m = (t) => {
  throw TypeError(t);
}, h = (t, e2, a2, n) => {
  for (var s = n > 1 ? void 0 : n ? B(e2, a2) : e2, r = t.length - 1, i; r >= 0; r--)
    (i = t[r]) && (s = (n ? i(e2, a2, s) : i(s)) || s);
  return n && s && u(e2, a2, s), s;
}, M = (t, e2, a2) => e2.has(t) || m("Cannot " + a2), c = (t, e2, a2) => (M(t, e2, "read from private field"), a2 ? a2.call(t) : e2.get(t)), d = (t, e2, a2) => e2.has(t) ? m("Cannot add the same private member more than once") : e2 instanceof WeakSet ? e2.add(t) : e2.set(t, a2);
const w = () => function(t) {
  var e$1, a$1, n, s;
  let r = class extends t {
    constructor() {
      super(...arguments), this.smallBreakpointWatcher = window.matchMedia(r.createMediaQueryString(I.DEFAULT)), this.mediumBreakpointWatcher = window.matchMedia(r.createMediaQueryString(I.MEDIUM)), this.largeBreakpointWatcher = window.matchMedia(r.createMediaQueryString(I.LARGE)), this.xLargeBreakpointWatcher = window.matchMedia(r.createMediaQueryString(I.XLARGE)), this.prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches, this.isSmallBreakpoint = this.smallBreakpointWatcher.matches, this.isMediumBreakpoint = this.mediumBreakpointWatcher.matches, this.isLargeBreakpoint = this.largeBreakpointWatcher.matches, this.isXLargeBreakpoint = this.xLargeBreakpointWatcher.matches, d(this, e$1, ({ matches: i }) => {
        this.isSmallBreakpoint = i;
      }), d(this, a$1, ({ matches: i }) => {
        this.isMediumBreakpoint = i;
      }), d(this, n, ({ matches: i }) => {
        this.isLargeBreakpoint = i;
      }), d(this, s, ({ matches: i }) => {
        this.isXLargeBreakpoint = i;
      });
    }
    static createMediaQueryString(i) {
      return `(min-width: ${i}px)`;
    }
    /** Matches small but doesn't match medium. */
    get matchesUpToSmall() {
      return !this.isMediumBreakpoint;
    }
    /** Matches small and medium but doesn't match large. */
    get matchesUpToMedium() {
      return !this.isLargeBreakpoint;
    }
    /** Matches small, medium, and large but doesn't match x-large. */
    get matchesUpToLarge() {
      return !this.isXLargeBreakpoint;
    }
    /** Matches all breakpoints up to x-large. */
    get matchesUpToXLarge() {
      return this.isXLargeBreakpoint;
    }
    /** Alias for matching small and medium breakpoints. */
    get isMobile() {
      return this.matchesUpToMedium;
    }
    /** Alias for matching the large (desktop) breakpoint. */
    get isDesktop() {
      return this.isLargeBreakpoint;
    }
    prerenderWatchMediaSetup() {
      this.smallBreakpointWatcher.addEventListener("change", c(this, e$1)), this.mediumBreakpointWatcher.addEventListener("change", c(this, a$1)), this.largeBreakpointWatcher.addEventListener("change", c(this, n)), this.xLargeBreakpointWatcher.addEventListener("change", c(this, s));
    }
  };
  return e$1 = /* @__PURE__ */ new WeakMap(), a$1 = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), h([
    et()
  ], r.prototype, "isSmallBreakpoint", 2), h([
    et()
  ], r.prototype, "isMediumBreakpoint", 2), h([
    et()
  ], r.prototype, "isLargeBreakpoint", 2), h([
    et()
  ], r.prototype, "isXLargeBreakpoint", 2), h([
    e
  ], r.prototype, "prerenderWatchMediaSetup", 1), r = h([
    a("WatchMedia")
  ], r), r;
};
export {
  w
};
